export const APP_SHOW_VERSION_QUERY_PARAM: string = 'showVersion';
export const APP_VERSION_META_TAG_NAME: string = 'app-version';
export const APP_VERSION_META_TAG_HID: string = 'app-version';
